import {
  FETCH_STONE_COLOR_REQUEST,
  FETCH_STONE_COLOR_SUCCESS,
  FETCH_STONE_COLOR_FAILURE,
  ADD_STONE_COLOR_REQUEST,
  ADD_STONE_COLOR_SUCCESS,
  ADD_STONE_COLOR_FAILURE,
  UPDATE_STONE_COLOR_REQUEST,
  UPDATE_STONE_COLOR_SUCCESS,
  UPDATE_STONE_COLOR_FAILURE,
  DELETE_STONE_COLOR_REQUEST,
  DELETE_STONE_COLOR_SUCCESS,
  DELETE_STONE_COLOR_FAILURE,
  STONE_COLOR_FORM_ERROR,
  STONE_COLOR_FORM_SUCCESS,
  SET_STONE_COLOR_EDIT,
  CLEAR_STONE_COLOR_EDIT,
} from '../../../../types/masters/stoneAttribute/stoneColor/stoneColorTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingStoneColor: null,
};

const stoneColorReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STONE_COLOR_REQUEST:
    case ADD_STONE_COLOR_REQUEST:
    case UPDATE_STONE_COLOR_REQUEST:
    case DELETE_STONE_COLOR_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STONE_COLOR_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_STONE_COLOR_SUCCESS:
    case UPDATE_STONE_COLOR_SUCCESS:
    case DELETE_STONE_COLOR_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_STONE_COLOR_FAILURE:
    case ADD_STONE_COLOR_FAILURE:
    case UPDATE_STONE_COLOR_FAILURE:
    case DELETE_STONE_COLOR_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case STONE_COLOR_FORM_ERROR:
      return { ...state, loading: false, formError: action.payload };
    case STONE_COLOR_FORM_SUCCESS:
      return { ...state, loading: false, formSuccess: action.payload };
    case SET_STONE_COLOR_EDIT:
      return { ...state, editingStoneColor: action.payload };
    case CLEAR_STONE_COLOR_EDIT:
      return { ...state, editingStoneColor: null };
    default:
      return state;
  }
};

export default stoneColorReducer; 